/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { combineReducers } from 'redux'

import api from '../api/reducer'
import phone from '../containers/Phone/reducer'
import passcode from '../containers/Passcode/reducer'
import signup from '../containers/Signup/reducer'
import activation from '../containers/Activation/reducer'
import schedule from '../containers/Schedule/reducer'
import nav from '../containers/Nav/reducer'
import app from '../containers/App/reducer'
import assessment from '../containers/Assessment/reducer'
import payment from '../containers/Payment/reducer'

import { LOGOUT } from '../containers/App/action-types'

const containers = {
  containers: combineReducers({
    phone,
    passcode,
    signup,
    activation,
    schedule,
    nav,
    app,
    assessment,
    payment
  })
}

const allReducers = combineReducers({
  ...containers,
  api
})

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined
  }

  return allReducers(state, action)
}

export default rootReducer
